
  import { createRoot } from "react-dom/client";
  import App from "./app/App.tsx";
  import "./styles/index.css";
  import { startNativeTextSizing } from "./app/native/textSizing";

  void startNativeTextSizing();
  createRoot(document.getElementById("root")!).render(<App />);
